import { Popper, styled } from '@mui/material'

export const StyledPopper = styled(Popper)(({ theme }) => ({
  padding: '10px',
  filter: 'drop-shadow(0px 4.23298px 15.8737px rgba(0, 0, 0, 0.15))',
  borderRadius: '8px',
  backgroundColor: theme.palette.grey[50],
}))
